import { useContext } from 'react';
import {
  EmbeddedAuthContext,
  EmbeddedAuthContextValue,
} from './EmbeddedAuthProvider';

export function useEmbeddedAuth(): EmbeddedAuthContextValue {
  const context = useContext(EmbeddedAuthContext);
  if (!context) {
    throw new Error(
      'useEmbeddedAuth must be used within an EmbeddedAuthProvider'
    );
  }
  return context;
}
